<template>
    <div id="fuel_pricing_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="fuelPricingHeader" v-if="$route.params.id > 0">Update Fuel Pricing</span>
                    <span class="page-title" id="fuelPricingHeader" v-else>Add Fuel Pricing</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackFuelPricingList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="fuelPricingForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="check_status">Type:</label>
                                        <v-select v-model="pricing_type" name="pricing_type" placeholder="Select Type."
                                                label="text"
                                                :options="pricingTypeArr" id="pricing_type" class="close-remove" @input="onTypeSelect($event)">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="check_status">Item:</label>
                                        <v-select v-model="item" name="item" placeholder="Select Item."
                                                label="text"
                                                :options="componentArr">
                                        </v-select>
                                        <div class="field-error">{{item_error_msg}}</div>
                                    </div>
                                    <template v-if="(isCustomer && isCreatePage==false) || isCustomerContract">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_id">Customer:</label>
                                            <v-select v-model="customer_id" name="customer_id" id="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Customer...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{customer_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isCustomerContract">
                                        <div class="col form-group">
                                            <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                            <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                    label="text"
                                                    :options="contractTypeArr">
                                            </v-select>
                                            <div class="field-error">{{contract_type_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isUnit && isCreatePage==false">
                                        <div class="col form-group">
                                            <label class="control-label require" for="vehicle_id">Asset:</label>
                                            <v-select v-model="vehicle_id" id="vehicle_id" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Asset" class='custom-ci-auto-search close-remove'>
                                                <template slot="no-options">
                                                    Search Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{vehicle_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isCustomerClass">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_class_id">Customer Class:</label>
                                            <v-select v-model="customer_class_id" name="customer_class_id" placeholder="Select Customer Class."
                                                    label="text"
                                                    :options="customerClassArr">
                                            </v-select>
                                            <div class="field-error">{{customer_class_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-if="isLocation">
                                        <div class="col form-group">
                                            <label class="control-label require" for="location_id">Location:</label>
                                            <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                    label="text"
                                                    :options="locationArr">
                                            </v-select>
                                            <div class="field-error">{{location_error_msg}}</div>
                                        </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require" for="effective_date">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ effective_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="check_status">Price Type:</label>
                                        <v-select v-model="price_type" name="price_type" placeholder="Select Price Type."
                                                label="text"
                                                :options="priceValueTypesArr" id="price_type" class="close-remove" @input="onPriceTypeSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{ price_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="price_value">Price Value:</label>
                                        <input type="text" class="form-control"
                                        v-model="price_value"
                                        @blur="price_value = leaveFocus($event)"
                                        @focus="price_value = enterVal($event)"
                                        @input="validateInput" id="price_value" placeholder="Enter Price Value" name="price_value" @keypress="isNumberKey($event)">
                                        <div class="field-error">{{ price_value_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="field-error check-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>

                            </form>
                            <template v-if="isCreatePage && isCustomer">
                              <div class="field-error">{{customer_error_msg}}</div>
                              <fuel-price-customer-list :fuelCustomerListVal="'fuelCustomerList'" @fuelPricingCustomerId="getCustomerData"></fuel-price-customer-list>
                              <p>&nbsp;</p>
                            </template>
                            <!-- <template v-if="isCreatePage && isCustomer 
                                            <data-table-filter-config :moduleName="'fuelPriceCustomerList'" :key="componentKey" @cancelSelection="cancelAll" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
                                            <div class="field-error">{{customer_error_msg}}</div>
                                            <section class="bg-white data-table">
                                                    <custom-pagination
                                                        :page-changed="onPageChange"
                                                        :per-page-changed="onPerPageChange" :moduleName="'fuelPriceCustomerList'" :key="componentKey"  :position="'top'">
                                                    </custom-pagination>
                                                    <vue-good-table
                                                        ref="listFuelReadingCustomerTable"
                                                        mode="remote"
                                                        title="Customer"
                                                        @on-page-change="onPageChange"
                                                        @on-selected-rows-change="selectionChanged"
                                                        @on-column-filter="onColumnFilter"
                                                        @on-per-page-change="onPerPageChange"
                                                        @on-sort-change="onSortChange"
                                                        @on-select-all="onSelectAll"
                                                        @on-row-click="onRowClick"
                                                        :totalRows="totalRecords"
                                                        :columns="userColumns"
                                                        :rows="rows"
                                                        :pagination-options="{
                                                            enabled: false,
                                                            setCurrentPage:listCurrentPage,
                                                            perPage: perPage,
                                                        }"
                                                        :select-options="{
                                                        enabled: true,
                                                        selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                                        selectionInfoClass: 'custom-class',
                                                        selectionText: 'rows selected',
                                                        clearSelectionText: 'clear',
                                                        }"
                                                        :search-options="{
                                                        enabled: false,
                                                        }">

                                                    </vue-good-table>

                                                    <custom-pagination
                                                        :page-changed="onPageChange"
                                                        :per-page-changed="onPerPageChange"
                                                        >
                                                    </custom-pagination>
                                            </section>
                                  </template> -->
                                  <template v-if="isCreatePage && isUnit ">
                                    <div class="field-error">{{vehicle_error_msg}}</div>
                                    <fuel-price-asset-list :fuelAssetListVal="'fuelAssetList'" @fuelPricingAssetId="getAssetData"></fuel-price-asset-list>
                                    <p>&nbsp;</p>
                                  </template>
                                 <!-- <template v-if="isCreatePage && isUnit ">
                                        <data-table-asset-filter-config :moduleName="'fuelPriceAssetList'" :key="componentKey"></data-table-asset-filter-config>
                                      <div class="field-error">{{vehicle_error_msg}}</div>
                                        <section class="bg-white data-table">
                                            <custom-asset-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange" :moduleName="'fuelPriceAssetList'" :key="componentKey" :position="'top'">
                                            </custom-asset-pagination>

                                                <vue-good-table
                                                        ref="listFuelReadingVehicleTable"
                                                        mode="remote"
                                                        title="Asset"
                                                        @on-page-change="onPageChange"
                                                        @on-selected-rows-change="selectionChanged"
                                                        @on-column-filter="onColumnFilter"
                                                        @on-per-page-change="onPerPageChange"
                                                        @on-sort-change="onSortChange"
                                                        :totalRows="totalRecords"
                                                        :columns="columnsAsset"
                                                        :rows="assetRows"
                                                        @on-select-all="onSelectAll"
                                                        @on-row-click="onRowClick"
                                                        :pagination-options="{
                                                            enabled: false,
                                                            position: 'both',
                                                            setCurrentPage:listCurrentPage,
                                                            perPage: perPage,
                                                            perPageDropdown:dropDownPerPage,
                                                            dropdownAllowAll: false,
                                                        }"
                                                        :select-options="{
                                                            enabled: true,
                                                            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                                            selectionInfoClass: 'custom-class',
                                                            selectionText: 'rows selected',
                                                            clearSelectionText: 'clear',
                                                        }"
                                                        :search-options="{
                                                            enabled: false,
                                                        }">

                                                </vue-good-table>
                                                <custom-asset-pagination
                                                    :page-changed="onPageChange"
                                                    :per-page-changed="onPerPageChange">
                                                </custom-asset-pagination>

                                        </section>
                                 </template> -->
                                   <div class="btn-groups">
                                    <button type="submit" id="CreateFuelPricingBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateFuelPricing" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateFuelPricingBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateFuelPricing" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueFuelPricingBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateFuelPricing(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelFuelPricingBtn" class="btn btn-tertiary" v-on:click.prevent="BackFuelPricingList">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

// import customPagination from "@/components/layout/CustomPagination";
import {dataTableMixins} from '../mixins/dataTableMixins';


export default {
    name: "FuelPricingCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Fuel Pricing | " +process.env.COPYRIGHT_NAME : "Create Fuel Pricing | " +process.env.COPYRIGHT_NAME
        }
    },
    components: {
        
        
        customAssetPagination: () => import('@/components/layout/CustomPagination'),
        fuelPriceCustomerList: () => import('@/components/CustomerList.vue'),
        fuelPriceAssetList: () => import('@/components/AssetList.vue'),
        
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        pricing_type:{
            text: "System Override",
            value: "system_override"
        },
        userColumns:[],
        pricingTypeArr:[
            {
                text: "System Override",
                value: "system_override"
            },
            {
                text: "Customer Override",
                value: "customer_override"
            },
            {
                text: "Customer Class Override",
                value: "customer_class_override"
            },
            {
                text: "Customer/Contract Override",
                value: "customer_contract_override"
            },
            {
                text: "Unit Override",
                value: "unit_override"
            },
            {
                text: "Location Override",
                value: "location_override"
            },
        ],
        item:"",
        item_error_msg:"",
        componentArr:[],
        customer_id:"",
        customerArr:[],
        customer_class_id:"",
        customerClassArr:[],
        contract_type_id:"",
        contractTypeArr:[],
        vehicle_id:"",
        vehicleArr:[],
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        effective_date:"",
        effective_date_error_msg:"",
        common_error_msg:"",
        customer_error_msg:"",
        customer_class_error_msg:"",
        contract_type_error_msg:"",
        vehicle_error_msg:"",
        isCustomer:false,
        isCustomerClass:false,
        isCustomerContract:false,
        isUnit:false,
        isLocation:false,
        location_id:"",
        location_error_msg:"",
        locationArr:[],
        priceValueTypesArr:[
            {
                text: "Sales Price",
                value: "sales_price"
            },
            {
                text: "Amount Over Cost",
                value: "amount_over_cost"
            },
            {
                text: "% Over Cost",
                value: "percent_over_cost"
            },
        ],
        price_type:"",
        price_type_error_msg:"",
        price_value:"",
        price_value_error_msg:"",
        rows: [],
        totalRecords: 0,
        columns: [
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    width:'140px',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterFn: this.onColumnFilter,
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'work_phone',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State',
                    field: 'state',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Stage',
                    field: 'stage',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Unverified','Active', 'Inactive'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Outstanding AR',
                    field: 'outstanding_ar',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Outstanding AR", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            columnsAsset: [
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vin',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Asset Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Ownership',
                    field: 'ownership',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ownership", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned Facility',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Odometer Reading',
                    field: 'odometer_reading',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reading Updated At',
                    field: 'odometer_reading_time',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Purchase Date',
                    field: 'purchase_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date Added',
                    field: 'date_added',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Is Standard',
                    field: 'is_standard_unit',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Select Is Standard", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['YES', 'NO'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
            ],
            assetColumns:[],
            selectedArray:[],
            isCreatePage:true,
            selectedAssetArray:[],
            assetRows:[],
            pageArr:[],
            componentKey:0,
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_pricing') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
   mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['contractType','customerClass','internalFuel','fuelLocations']);
        var path = window.location.pathname;
        var segments = path.split("/");

        setTimeout(function () {

            if (segments[3]) {
                self.loadFuelPricingData();
                self.isCreatePage=false;
            }
        }, 100);
   },
   methods: {
     validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      if(evt.target.value > 999999.99) {
        self.price_value_error_msg = "Amount value exceed";
      } else {
        self.price_value_error_msg = "";
      }
    },
      // enterVal:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("ENTER  ==", evt.target.value);
      //   this.price_value = evt.target.value;
      //   this.price_value = evt.target.value.replace(/\,/g,"");
      // },
      // leaveFocus:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("focus ==", evt.target.value);
      //   this.price_value =  this.amountFormat(evt.target.value);
      // },
      amountFormat(amount) {
          const formatter = new Intl.NumberFormat('en-US', {
              minimumFractionDigits:2,
              maximumFractionDigits:2
          });

          return formatter.format(amount);
      },
        cancelAll: function (cancelAll) {
          this.$refs.listFuelReadingCustomerTable.unselectAllInternal();
        },
       loadList(){
        var self = this;
       },
       BackFuelPricingList() {
        var self = this;
        self.$router.push("/fuel-pricing/list");
      },
      onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
      },
      onSearchAsset(search, loading) {
        var self = this;
        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
      },
      onSortChange(params) {
    
        var self = this;
        this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            page:1,
        });
        
        if(self.isCreatePage && self.isCustomer ){
            this.loadFilters('fuelPriceCustomerList');
        }
        if(self.isCreatePage && self.isUnit){
            //alert("in condition")
            this.loadFilters('fuelPriceAssetList');
        }
        

      },
      onPageChange(params) {
        
        var self = this;
        this.updateParams({page: params.currentPage});
        this.listCurrentPage = params.currentPage;

        if(self.isCreatePage && self.isCustomer ){
                    this.loadCustomerList();
        }
        if(self.isCreatePage && self.isUnit){
                    this.loadAssetList();
        }

      },
      getCustomerData(custData){
        var self = this;
        if(self.isCreatePage && self.isCustomer && custData){
            self.selectedAssetArray=[];
            if ($.inArray(custData, self.selectedArray) != -1)
            {
              var index = self.selectedArray.indexOf(custData);
              if (index > -1) {
                  self.selectedArray.splice(index, 1);
              }
            }else{
              self.selectedArray.push(custData);
            }
            console.log(self.selectedArray);
        }
      },
      getAssetData(assetData){
        var self = this;
        if(self.isCreatePage && self.isUnit && assetData){
            self.selectedArray=[];
            if ($.inArray(assetData, self.selectedAssetArray) != -1)
            {
              var index = self.selectedAssetArray.indexOf(assetData);
              if (index > -1) {
                  self.selectedAssetArray.splice(index, 1);
              }
            }else{
              self.selectedAssetArray.push(assetData);
            }
        }
      },
      // onRowClick(params){
      //      var self = this;
      //       setTimeout(function(){
      //           $('.vgt-selection-info-row').css({'display':'none'});
      //       },1);
      //           if(self.isCreatePage && self.isCustomer ){
      //           self.selectedAssetArray=[];
      //           if ($.inArray(params.row.id, self.selectedArray) != -1)
      //           {
      //                   // self.selectedArray.splice(i,1);
      //               var index = self.selectedArray.indexOf(params.row.id);
      //               if (index > -1) {
      //                   self.selectedArray.splice(index, 1);
      //               }
      //           }else{
      //               self.selectedArray.push(params.row.id);
      //           }
      //       }
      //        if(self.isCreatePage && self.isUnit ){
      //           self.selectedArray=[];
      //           if ($.inArray(params.row.id, self.selectedAssetArray) != -1)
      //           {
      //                   // self.selectedArray.splice(i,1);
      //               var index = self.selectedAssetArray.indexOf(params.row.id);
      //               console.log(index);
      //               if (index > -1) {
      //                   self.selectedAssetArray.splice(index, 1);
      //               }
      //           }else{
      //               self.selectedAssetArray.push(params.row.id);
      //           }
      //           console.log(self.selectedAssetArray); 
      //       }
      //       // console.log("AssetArr"+self.selectedAssetArray);
      //       // console.log("CustomerArr"+self.selectedArray);
      // },
     selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
      findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                return i;
                }
            }
            return -1;
      },
      loadCustomerList() {

            var self = this;

            self.loading = true;
            //get selected customers ids

            var selectedRows = [];
                //because on first load list not initialize
                // var data = this.$refs['listCustomerTable'].selectedRows;
                // for ( var i = 0; i < data.length; i++ ) {
                //     selectedRows.push(this.$refs['listCustomerTable'].selectedRows[i].id)
                // }
            // self.dropDownPerPage=[];
            var fields = {

                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                flag: self.flag,
                selectedRows:selectedRows,
                action:self.action,
                selectedAll:self.serverParams.selectedAll

            };

            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/customer/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;

                            for(var k=0;k< self.rows.length;k++){
                                if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                                        self.$set(self.rows[k], 'vgtSelected', true);
                                    }
                            }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')

                }
            });
        },
        loadAssetList() {

            var self = this;
            self.loading = true;
            //self.serverParams.columnFilters = params;

            var selectedRows = [];
            self.serverParams.perPage=25;
            //because on first load list not initialize
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll

                };

            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/asset/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                            self.assetRows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            for(var k=0;k< self.assetRows.length;k++){
                            if ($.inArray(self.assetRows[k].id, self.selectedAssetArray) >= 0) {
                                self.$set(self.assetRows[k], 'vgtSelected', true);
                            }
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-asset-list-fuel')
                }
            });
        },
       CreateFuelPricing(flag) {

            var self = this;
            var error = false;
            self.item_error_msg = "";
            self.effective_date_error_msg = "";
            self.common_error_msg = "";
            self.price_type_error_msg = "";
            self.price_value_error_msg = "";

            if (!self.item || self.item == null || self.item.value == "") {
                self.item_error_msg = "Item Required.";
                error = true;
            }

            if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
                self.effective_date_error_msg = "Effective Date Required.";
                error = true;
            }

            if (!self.price_type || self.price_type == null || self.price_type == "") {
                self.price_type_error_msg = "Price Type Required.";
                error = true;
            }

            if (self.price_value == null || self.price_value == "") {
                self.price_value_error_msg = "Price Value Required.";
                error = true;
            }

            if ((self.isCustomer && self.isCreatePage==false) || self.isCustomerContract) {
                self.customer_error_msg = "";
                if (!self.customer_id || self.customer_id == null || self.customer_id == "") {
                    self.customer_error_msg = "Customer Required.";
                    error = true;
                }
            }
            if(self.isCreatePage==true && self.isCustomer && self.isCustomerContract==false){
                self.customer_error_msg = "";

                if(self.selectedArray.length<=0){
                    self.customer_error_msg = "Please Select Customer.";
                    error = true;

                }
            }

            if (self.isCustomerClass) {
                self.customer_class_error_msg = "";
                if (!self.customer_class_id || self.customer_class_id == null || self.customer_class_id == "") {
                    self.customer_class_error_msg = "Customer Class Required.";
                    error = true;
                }
            }

            if (self.isCustomerContract) {
                self.contract_type_error_msg = "";
                if (!self.contract_type_id || self.contract_type_id == null || self.contract_type_id == "") {
                    self.contract_type_error_msg = "Contract Type Required.";
                    error = true;
                }
            }

            if (self.isUnit && self.isCreatePage==false ) {
                self.vehicle_error_msg = "";
                if (!self.vehicle_id || self.vehicle_id == null || self.vehicle_id == "") {
                    self.vehicle_error_msg = "Asset Required.";
                    error = true;
                }
            }
             if(self.isCreatePage==true && self.isUnit){
                self.vehicle_error_msg = "";

                if(self.selectedAssetArray.length<=0){

                    self.vehicle_error_msg = "Please Select Unit.";
                    error = true;

                }
            }

            if (self.isLocation) {
                self.location_error_msg = "";
                if (!self.location_id || self.location_id == null || self.location_id == "") {
                    self.location_error_msg = "Location Required.";
                    error = true;
                }
            }

            if (!error) {

                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]) {
                    $("#CreateFuelPricingBtn").val("Updating ...");
                    $("#CreateFuelPricingBtn").prop("disabled", true);
                    $("#cancelFuelPricingBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueFuelPricingBtn").val("Saving ...");
                        $("#CreateFuelPricingBtn").prop("disabled", true);
                        $("#createAndContinueFuelPricingBtn").prop("disabled", true);
                        $("#cancelFuelPricingBtn").prop("disabled",true);

                    } else{

                        $("#CreateFuelPricingBtn").val("Saving ...");
                        $("#CreateFuelPricingBtn").prop("disabled", true);
                        $("#createAndContinueFuelPricingBtn").prop("disabled", true);
                        $("#cancelFuelPricingBtn").prop("disabled",true);
                    }
                }

                var fields = $("#fuelPricingForm").serializeArray();

                // .replace(/\,/g,"")
                var idx = fields.findIndex(obj => obj.name == 'price_value');
                if (idx != -1) {
                  fields.push({
                      name: "price_value",
                      value: fields[idx].value.replace(/\,/g,"")
                  });
                  fields.splice(idx, 1);
                }
                fields.push({name: "flag", value: self.pricing_type.value});
                fields.push({name: "item_id", value: self.item.value});
                fields.push({name: "price_type", value: self.price_type.value});

                if (self.isCustomer) {
                    if(self.isCreatePage==true){
                        fields.push({name: "customer_id", value: JSON.stringify(self.selectedArray)});
                    }else{
                        fields.push({name: "customer_id", value: self.customer_id.value});
                    }
                }else if (self.isCustomerClass) {
                    fields.push({name: "customer_class_id", value: self.customer_class_id.value});
                }else if (self.isCustomerContract) {
                    fields.push({name: "customer_id", value: self.customer_id.value});
                    fields.push({name: "contract_type_id", value: self.contract_type_id.value});
                }else if (self.isUnit) {

                    if(self.isCreatePage==true){
                        fields.push({name: "vehicle_id", value: JSON.stringify(self.selectedAssetArray)});
                    }else{
                        fields.push({name: "vehicle_id", value: self.vehicle_id.value});
                    }

                }else if (self.isLocation) {
                    fields.push({name: "location_id", value: self.location_id.value});
                }
                fields.push({ name: "id", value: segments[3] });

                if (segments[3] == undefined) {
                    fields.push({ name: "identifier", value: "create" });
                }else{
                    fields.push({ name: "identifier", value: "update" });
                }

                $.ajax({
                    url: process.env.ROOT_API + "/fuel-pricing/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        if (segments[3]) {
                            $("#CreateFuelPricingBtn").val("Update");
                            $("#CreateFuelPricingBtn").prop("disabled", false);
                            $("#cancelFuelPricingBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueFuelPricingBtn").val("Save and Continue");
                                $("#CreateFuelPricingBtn").prop("disabled", false);
                                $("#createAndContinueFuelPricingBtn").prop("disabled", false);
                                $("#cancelFuelPricingBtn").prop("disabled",false);

                            } else{

                                $("#CreateFuelPricingBtn").val("Save");
                                $("#CreateFuelPricingBtn").prop("disabled", false);
                                $("#createAndContinueFuelPricingBtn").prop("disabled", false);
                                $("#cancelFuelPricingBtn").prop("disabled",false);
                            }
                        }

                        if (data.status == "success") {

                            if (flag == "Save and Continue") {

                                self.item = "";
                                self.pricing_type = { text: "System Override", value:"system_override"};
                                self.effective_date = "";
                                self.isCustomer = false;
                                self.isCustomerClass = false;
                                self.isCustomerContract = false;
                                self.isUnit = false;
                                self.customer_id = "";
                                self.customer_class_id = "";
                                self.contract_type_id = "";
                                self.vehicle_id = "";
                                self.location_id = "";
                                self.price_type = "";
                                self.price_value = "";
                                self.self.selectedArray=[];
                                self.self.selectedAssetArray=[];
                            } else{
                                self.$router.push("/fuel-pricing/list");
                            }

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                // $("#errorMsg").html(err);
                                // $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    // $(".alert-warning").removeClass("show");
                                    // $(".alert-warning").addClass("hide");
                                    self.common_error_msg = "";
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3]) {
                            $("#CreateFuelPricingBtn").val("Update");
                            $("#CreateFuelPricingBtn").prop("disabled", false);
                            $("#cancelFuelPricingBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueFuelPricingBtn").val("Save and Continue");
                                $("#CreateFuelPricingBtn").prop("disabled", false);
                                $("#createAndContinueFuelPricingBtn").prop("disabled", false);
                                $("#cancelFuelPricingBtn").prop("disabled",false);

                            } else{

                                $("#CreateFuelPricingBtn").val("Save");
                                $("#CreateFuelPricingBtn").prop("disabled", false);
                                $("#createAndContinueFuelPricingBtn").prop("disabled", false);
                                $("#cancelFuelPricingBtn").prop("disabled",false);
                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-pricing-create');
                    }
                });

            }else{
                self.errorValidationFocus();
            }

      },
      loadFuelPricingData() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/fuel-pricing/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {

                    self.pricing_type = {
                        text: data.content.flag_text,
                        value: data.content.flag
                    };

                    self.item = {
                        text: data.content.itemCode + " | " + data.content.itemName,
                        value: data.content.item_id
                    };

                    self.effective_date = data.content.effective_date;

                    self.price_type = {
                        text: data.content.price_type_text,
                        value: data.content.price_type
                    };

                    self.price_value = self.amountFormat(data.content.price_value);

                    if (self.pricing_type.value == "customer_override") {
                        self.isCustomer = true;

                        self.customer_id = {
                            text: data.content.custCode + " | " + data.content.custName,
                            value: data.content.customer_id
                        };
                    } else if (self.pricing_type.value == "customer_class_override") {
                        self.isCustomerClass = true;

                        self.customer_class_id = {
                            text: data.content.custClassCode + " | " + data.content.custClassName,
                            value: data.content.customer_class_id
                        };

                    } else if (self.pricing_type.value == "customer_contract_override") {
                        self.isCustomerContract = true;

                        self.pricing_type.text = "Customer/Contract Override";

                        self.customer_id = {
                            text: data.content.custCode + " | " + data.content.custName,
                            value: data.content.customer_id
                        };

                        self.contract_type_id = {
                            text: data.content.contTypeCode + " | " + data.content.contTypeName,
                            value: data.content.contract_type_id
                        };

                    } else if (self.pricing_type.value == "unit_override") {
                        self.isUnit = true;

                        var vehicleData = data.content.unit_no;
                        if(data.content.vtCode != null && data.content.vtCode != ''){
                            vehicleData += " | " + data.content.vtCode;
                        }

                        if(data.content.unit_name != null && data.content.unit_name != ''){
                            vehicleData += " | " + data.content.unit_name;
                        }

                        if(data.content.locName != null && data.content.locName != ''){
                            vehicleData += " | " + data.content.locName;
                        }

                        self.vehicle_id = {
                            text: vehicleData,
                            value: data.content.vehicle_id
                        };
                    } else if (self.pricing_type.value == "location_override") {
                        self.isLocation = true;

                        self.location_id = {
                            text: data.content.locationName + " | " + data.content.locCode,
                            value: data.content.location_id
                        };
                    }


                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fuel-pricing-details');
            }
        });
      },
      onTypeSelect(event){
          var self = this;
          self.isCustomer = false;
          self.isCustomerClass = false;
          self.isCustomerContract = false;
          self.isUnit = false;
          self.isLocation = false;
          self.selectedAssetArray=[];
          self.selectedArray=[];
          setTimeout(function(){
              $('thead tr th:first-child').text('');
          },300);
          if (self.pricing_type != null) {
              if (self.pricing_type.value == "customer_override") {
                  self.isCustomer = true;
                  self.customer_error_msg = "";
                  self.componentKey += 1;
                  self.serverParams.columnFilters=[];
                  self.loadCustomerList();
              } else if (self.pricing_type.value == "customer_class_override") {
                  self.isCustomerClass = true;
                  self.customer_class_error_msg = "";
              } else if (self.pricing_type.value == "customer_contract_override") {
                //   self.isCustomer = true;
                  self.isCustomerContract = true;
                  self.customer_error_msg = "";
                  self.contract_type_error_msg = "";
              } else if (self.pricing_type.value == "unit_override") {
                  self.isUnit = true;
                  self.vehicle_error_msg = "";
                  self.componentKey += 1;
                   self.serverParams.columnFilters=[];
                  self.loadAssetList();
              } else if (self.pricing_type.value == "location_override") {
                  self.isLocation = true;
                  self.location_error_msg = "";
              }
          }

      },
      isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
      },
      onPriceTypeSelect(event) {
        var self = this;
        self.price_type_error_msg = "";
        if (self.price_value != "") {
            self.price_value = "";
            self.price_value_error_msg = "";
        }
      }
   }
}

</script>



// WEBPACK FOOTER //
// src/components/FuelPricingCreate.vue